"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from "react";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { cicToType } from "@/helpers/Helpers";
import Link from "next/link";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropPart } from "@/generated/models/ApiDropPart";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import WaveDropTime from "./time/WaveDropTime";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import Image from "next/image";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
interface WaveDropQuoteProps {
  readonly drop: ApiDrop | null;
  readonly partId: number;
  readonly onQuoteClick: (drop: ApiDrop) => void;
}
const WaveDropQuote: React.FC<WaveDropQuoteProps> = t0 => {
  const $ = _c(57);
  const {
    drop,
    partId,
    onQuoteClick
  } = t0;
  const [quotedPart, setQuotedPart] = useState(null);
  let t1;
  if ($[0] !== drop || $[1] !== partId) {
    t1 = () => {
      if (!drop) {
        return;
      }
      const part_0 = drop.parts.find(part => part.part_id === partId);
      if (!part_0) {
        return;
      }
      setQuotedPart(part_0);
    };
    $[0] = drop;
    $[1] = partId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== drop) {
    t2 = [drop];
    $[3] = drop;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== drop) {
    t3 = () => {
      if (!drop) {
        return <div className="tw-h-full tw-w-full tw-max-w-full tw-rounded-md tw-overflow-hidden tw-bg-iron-900 tw-animate-pulse" />;
      }
      const resolvedPfp = drop.author.pfp ? resolveIpfsUrlSync(drop.author.pfp) : null;
      if (resolvedPfp) {
        return <div className="tw-relative tw-h-full tw-w-full"><Image src={resolvedPfp} alt={`${drop.author.handle}'s profile picture`} fill={true} sizes="24px" className="tw-rounded-md tw-object-cover tw-bg-transparent" /></div>;
      }
      return <div className="tw-h-full tw-w-full tw-max-w-full tw-rounded-md tw-overflow-hidden tw-bg-iron-900" />;
    };
    $[5] = drop;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderProfilePicture = t3;
  let t4;
  if ($[7] !== drop || $[8] !== onQuoteClick) {
    t4 = () => {
      if (drop?.wave.id && drop?.id) {
        onQuoteClick(drop);
      }
    };
    $[7] = drop;
    $[8] = onQuoteClick;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const goToQuoteDrop = t4;
  let t5;
  bb0: {
    if (!drop) {
      t5 = "";
      break bb0;
    }
    const waveDetails = drop.wave as unknown as {
      chat?: {
        scope?: {
          group?: {
            is_direct_message?: boolean;
          };
        };
      };
    } ?? undefined;
    const isDirectMessage = waveDetails?.chat?.scope?.group?.is_direct_message ?? false;
    let t6;
    if ($[10] !== drop.wave.id || $[11] !== isDirectMessage) {
      t6 = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      $[10] = drop.wave.id;
      $[11] = isDirectMessage;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = t6;
  }
  const waveHref = t5;
  let t6;
  let t7;
  if ($[13] !== goToQuoteDrop) {
    t6 = e => {
      e.stopPropagation();
      goToQuoteDrop();
    };
    t7 = e_0 => {
      if (e_0.key === "Enter" || e_0.key === " ") {
        e_0.preventDefault();
        e_0.stopPropagation();
        goToQuoteDrop();
      }
    };
    $[13] = goToQuoteDrop;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[16] !== renderProfilePicture) {
    t8 = <div className="tw-h-6 tw-w-6 tw-bg-iron-900 tw-relative tw-flex-shrink-0 tw-rounded-md"><div className="tw-rounded-md tw-h-full tw-w-full">{renderProfilePicture()}</div></div>;
    $[16] = renderProfilePicture;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== drop) {
    t9 = !!drop && <UserCICAndLevel level={drop.author.level} cicType={cicToType(drop?.author.cic)} size={UserCICAndLevelSize.SMALL} />;
    $[18] = drop;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `/${drop?.author.handle}`;
  const t11 = drop?.author.handle;
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link href={t10} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{t11}</Link></p>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t9) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-2">{t9}{t12}</div>;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== drop) {
    t14 = !!drop && <><div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" /><WaveDropTime timestamp={drop.created_at} /></>;
    $[26] = drop;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-2">{t13}{t14}</div>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== drop || $[32] !== waveHref) {
    t16 = drop && waveHref && <Link href={waveHref} className="tw-text-[11px] tw-leading-0 -tw-mt-1 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw_DURATION-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[31] = drop;
    $[32] = waveHref;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = <div>{t16}</div>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = quotedPart?.content ?? "";
  let t19;
  if ($[36] !== drop?.mentioned_users) {
    t19 = drop?.mentioned_users ?? [];
    $[36] = drop?.mentioned_users;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== drop?.referenced_nfts) {
    t20 = drop?.referenced_nfts ?? [];
    $[38] = drop?.referenced_nfts;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  const t21 = drop?.id;
  let t22;
  if ($[40] !== onQuoteClick || $[41] !== t18 || $[42] !== t19 || $[43] !== t20 || $[44] !== t21) {
    t22 = <div className="tw-mt-0.5"><DropPartMarkdownWithPropLogger partContent={t18} mentionedUsers={t19} referencedNfts={t20} textSize="sm" onQuoteClick={onQuoteClick} currentDropId={t21} /></div>;
    $[40] = onQuoteClick;
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t15 || $[47] !== t17 || $[48] !== t22) {
    t23 = <div className="tw-flex tw-flex-col tw-w-full">{t15}{t17}{t22}</div>;
    $[46] = t15;
    $[47] = t17;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t23 || $[51] !== t8) {
    t24 = <div className="tw-relative tw-group tw-w-full tw-flex tw-flex-col"><div className="tw-flex tw-gap-x-2">{t8}{t23}</div></div>;
    $[50] = t23;
    $[51] = t8;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t24 || $[54] !== t6 || $[55] !== t7) {
    t25 = <div className="tw-mt-1 tw-bg-iron-950 tw-rounded-xl tw-px-3 tw-py-3 tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-cursor-pointer" onClick={t6} onKeyDown={t7} role="button" tabIndex={0}>{t24}</div>;
    $[53] = t24;
    $[54] = t6;
    $[55] = t7;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  return t25;
};
export default WaveDropQuote;